import React, {Component} from 'react';
import {Container} from './styles.js';
import logo1 from '../../../assets/ativo/Ativo_15@4x_1@3x.png';
import logo2 from '../../../assets/group/Group_36@3x.png';
import { Spinner } from 'react-activity';
import {IoMdClose} from 'react-icons/io';
import api from '../../../services/api';

export default class Esqueci extends Component {

    constructor(props) {
        super(props);
        this.state = {
            default: false,
            userClass: 'div-input',
            user: '',
            carregando: false,
            enviado: false,
        }
    }

    async enviar(carregando) {
        this.setState({
            carregando: true
        });

         // Converter o e-mail para minúsculas
        const emailEmMinusculas = this.state.user.toLowerCase();

        try {
            await api.post('api/pwemail', {
                // email: this.state.user
                email: emailEmMinusculas
            }).then(res => {
                this.inputError(res.data.message)
            }).catch(e => {
                console.log(e.data);
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    async inputError(res) {
        switch (res) {
            case false:
                this.setState({
                    userClass: 'div-input-error',
                    carregando: false
                })
                break;
            case true:
                this.setState({
                    enviado: true
                });
                break;
            default:
                break;
        }
    }

    validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    render() {
        return(
            <Container>
                <div className="div-vermelha">
                        <button 
                            className="botao-modal" 
                            onClick={() => this.props.closeModal()}>
                            <IoMdClose color="#fff" className="i-close" />
                        </button>
                    <img 
                        alt=""
                        src={this.state.enviado ? logo2 : logo1}
                        className="vector-img" />
                </div>

                <div className="div-branca">
                        {
                            this.state.enviado ?
                            <div className="div-texto-sucesso">
                                <h1>E-mail enviado com sucesso!</h1>
                            </div>
                            :
                            <div className="div-textos">
                            <h2>Esqueceu a senha?</h2>
                            <h3>Digite o seu e-mail para receber um link para redefinir sua senha.</h3>
                            </div>
                        }

                    {
                        this.state.enviado ?
                        null :
                        <>
                        <div className={this.state.userClass}>
                            <input
                                ref={elem => (this.userInput = elem)}
                                value={this.state.user}
                                onFocus={() => {
                                    this.setState({
                                        userClass: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        userClass: 'div-input'
                                    })
                                }}
                                onChange={e => this.setState({
                                    user: e.target.value
                                })}
                                name="userName"
                                type="text"
                                // placeholder="Digite o seu usuário"
                                required 
                                />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Digite o seu e-mail</span>
                            </label>
                        </div>

                        {this.state.userClass === 'div-input-error' ?
                        <div className="div-invalido">
                            <span
                            className='texto-invalido'
                            >E-mail inválido</span>
                        </div>   
                        : null}
                        </>
                    }

                    <div className="div-botao">
                        <button
                            onClick={() => (this.validateEmail(this.state.user)) && this.state.userClass !== 'div-input-error'
                                ? this.state.enviado === false ? 
                                this.enviar(this.state.carregando)
                                // this.inputError('user')
                                 : this.props.closeModal()
                                : null}
                            className={(this.validateEmail(this.state.user)) && this.state.userClass !== 'div-input-error'
                                ? 'botaologin-active'
                                : this.state.enviado ? 'botaologin-enviado' : 'botaologin'}
                            >{
                            this.state.carregando === false ? 'Enviar senha por e-mail' 
                            : 
                            this.state.enviado ? 'Ir para o Painel do Restaurante' 
                            : 
                            <Spinner
                            className='spinner'
                            color="#fff" size={11} speed={1} animating={true} />}</button>
                    </div>

                </div>
            </Container>
        )
    }

}